/*
File: perform api actions
Author: SimonLu<luzuoqing@huya.com>
Date: 2020-03-16
*/
import React, { useState, useEffect, useCallback, useReducer } from 'react'
import { message as antdMessage } from 'antd'
import * as R from 'ramda'

const initialState = {
  isLoading: false,
  respCode: null,
  respData: null,
  error: null,
}

function reducer(state, action) {
  switch (action.type) {
    case 'update':
      return R.mergeLeft(action.payload, state)
    case 'reset':
      return initialState
    default:
      throw new Error('unknown action')
  }
}

export const useAction = (action, { notifyError = true, notifySucess = false } = {}) => {
  const [state, dispatch] = useReducer(reducer, initialState)

  const reset = useCallback(async () => {
    dispatch({ type: 'reset' })
  }, [])

  const perform = useCallback(async payload => {
    try {
      dispatch({
        type: 'update',
        payload: {
          isLoading: true,
        },
      })
      const resp = await action(payload)

      const { status, msg, message, data } = R.compose(
        R.defaultTo({}),
        R.prop('data'),
      )(resp)


      if (status !== 0) {
        notifyError && antdMessage.error(msg || message || '未知错误')
        return dispatch({
          type: 'update',
          payload: {
            isLoading: false,
            respCode: status,
            error: new Error(msg || message),
            respData: null,
          },
        })
      }

      notifySucess && antdMessage.success(msg || message)
      dispatch({
        type: 'update',
        payload: {
          isLoading: false,
          respData: data,
          respCode: status,
          error: null,
        },
      })
    } catch (err) {
      console.error(err)
      notifyError && antdMessage.error(err.message || '网络错误')
      dispatch({
        type: 'update',
        payload: {
          isLoading: false,
          respCode: status,
          error: err,
          respData: null,
        },
      })
    } finally {
      dispatch({
        type: 'update',
        payload: {
          isLoading: false,
        },
      })
    }
  }, [])
  return [state, perform, reset]
}
